import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { usePageContent } from "@/i18n/pageContent";

const TIMELINE = {
  it: [
    { year: "1958", title: "Fondazione", text: "Belgio, Francia, Germania, Italia, Lussemburgo, Paesi Bassi istituiscono la Comunità Economica Europea." },
    { year: "1973", title: "Primo allargamento", text: "Adesione di Danimarca e Irlanda." },
    { year: "1981", title: "Grecia", text: "La Grecia entra a far parte della Comunità." },
    { year: "1986", title: "Penisola Iberica", text: "Adesione di Portogallo e Spagna." },
    { year: "1995", title: "Centro-Nord", text: "Austria, Finlandia e Svezia diventano Stati membri." },
    { year: "2004", title: "Grande allargamento", text: "10 nuovi paesi: Cipro, Repubblica Ceca, Estonia, Ungheria, Lettonia, Lituania, Malta, Polonia, Slovacchia, Slovenia." },
    { year: "2007", title: "Est balcanico", text: "Bulgaria e Romania entrano nell'UE." },
    { year: "2013", title: "Croazia", text: "Ultimo paese ad aderire, completa l'attuale Unione a 27." },
    { year: "Oggi", title: "Candidati", text: "Albania, Macedonia del Nord, Montenegro, Serbia, Bosnia ed Erzegovina, Kosovo, Moldova, Ucraina e Georgia." },
  ],
  en: [
    { year: "1958", title: "Foundation", text: "Belgium, France, Germany, Italy, Luxembourg and the Netherlands establish the European Economic Community." },
    { year: "1973", title: "First enlargement", text: "Denmark and Ireland join." },
    { year: "1981", title: "Greece", text: "Greece becomes part of the Community." },
    { year: "1986", title: "Iberian Peninsula", text: "Portugal and Spain join." },
    { year: "1995", title: "Centre-North", text: "Austria, Finland and Sweden become Member States." },
    { year: "2004", title: "Great enlargement", text: "10 new countries: Cyprus, Czech Republic, Estonia, Hungary, Latvia, Lithuania, Malta, Poland, Slovakia, Slovenia." },
    { year: "2007", title: "Balkan East", text: "Bulgaria and Romania join the EU." },
    { year: "2013", title: "Croatia", text: "Last country to join, completing the current Union of 27." },
    { year: "Today", title: "Candidates", text: "Albania, North Macedonia, Montenegro, Serbia, Bosnia and Herzegovina, Kosovo, Moldova, Ukraine and Georgia." },
  ],
};

const FOOTER = {
  it: "L'adesione non segue scadenze fisse: dipende dal rispetto dei criteri europei in materia di democrazia, stato di diritto e standard economici. I paesi più avanzati nei negoziati — come Montenegro e Albania — potrebbero entrare nella seconda metà degli anni '20.",
  en: "Membership does not follow fixed deadlines: it depends on compliance with European criteria on democracy, the rule of law and economic standards. The countries most advanced in negotiations — such as Montenegro and Albania — could join in the second half of the 2020s.",
};

export default function RoadTo27() {
  const { i18n } = useTranslation();
  const c = usePageContent("roadTo27");
  const lang = i18n.language === "en" ? "en" : "it";
  return (
    <PageShell>
      <PageHero
        eyebrow={c.eyebrow}
        title={<>{c.titleA} <span className="italic">{c.titleB}</span>.</>}
        subtitle={c.subtitle}
        image="/road-to-27-hero.webp"
        imageFit="contain"
      />
      <section className="bg-white py-20 md:py-28">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <ol className="relative border-l border-[#e2e8f0] ml-3">
            {TIMELINE[lang].map((t, i) => (
              <li key={t.year} className={`pl-8 md:pl-12 pb-12 last:pb-0 reveal delay-${(i % 4) + 1}`}>
                <span aria-hidden className="absolute -left-[7px] mt-1 h-3 w-3 rounded-full bg-[#d4af37]" />
                <div className="flex items-baseline gap-4 flex-wrap">
                  <span className="font-display text-3xl md:text-4xl text-[#1a365d]">{t.year}</span>
                  <span className="text-[11px] tracking-[0.28em] uppercase text-[#475569]">{t.title}</span>
                </div>
                <p className="mt-3 text-[#475569] leading-[1.85] text-[15.5px]">{t.text}</p>
              </li>
            ))}
          </ol>
          <div className="mt-12 reveal">
            <p className="text-[#1e293b] leading-[1.9] text-base md:text-[17px] max-w-3xl">{FOOTER[lang]}</p>
            <Link to="/eu-euro" className="btn-outline mt-10">
              EU – Euro <ArrowRight size={14} strokeWidth={1.8} />
            </Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
